import { render, staticRenderFns } from "./CourseNavToolbar.vue?vue&type=template&id=5297c68d&scoped=true"
import script from "./CourseNavToolbar.vue?vue&type=script&lang=js"
export * from "./CourseNavToolbar.vue?vue&type=script&lang=js"
import style0 from "./CourseNavToolbar.vue?vue&type=style&index=0&id=5297c68d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5297c68d",
  null
  
)

export default component.exports